export default __webpack_public_path__ + "static/five-3a3d49d55476dc6c5f01d87c859fa2be.jpg";